
import { Card, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useState } from "react";
import Paginations from "../pagination/Paginations";

 
const TableComp = ({
  title,
  children,
  emptySColumnCount = 0,
  emptyEColumnCount = 0,
  pagination = { currentPage: 0, totalPages: 0, pageSize: 0, totalItems:0 },
  displayPagination = false,
  onPageChange,
}) => {

 
  const [currentPage, setCurrentPage] = useState(pagination.currentPage);
 
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (onPageChange) {
      onPageChange({ page: newPage });
    }
  };
 
  const renderEmptyColumns = (count) => {
    const columns = [];
    for (let i = 0; i < count; i++) {
      columns.push(<TableCell key={`empty-${i}`} w={"200px"}></TableCell>);
    }
    return columns;
  };
 
  return (
    // <Card
    //   backgroundColor={"#fff"}
    //   borderRadius={"35px"}
    //   w={"100%"}
    //   h={"auto"}
    //  sx={{padding:'20px',borderRadius:'25px'}}
    // >
    <>
      <TableContainer
        w={"full"}
        maxH={"80vh"}
        overflowY={"auto"}
        overflowX={"auto"}
        size={"medium"}
      >
        <Table  size={"medium"}>
          <TableHead>
            <TableRow >
              {renderEmptyColumns(emptySColumnCount)}
              {title &&
                title.map((item, index) => (
                  <TableCell
                    key={index}
                    
                    color={"#000"}
                    // fontSize={fontSize}
                    // whiteSpace="pre-wrap"
                    // wordWrap={false}
                    // textOverflow="ellipsis"
                    sx={{fontFamily:"Rosario",fontWeight:'600',fontSize:'18px',
                      
                      whiteSpace: "nowrap",  // Prevent wrap in headers
                      textAlign: "left",  // Align consistently
                    }}
                  >
                    {item.title}
                  </TableCell>
                ))}
              {renderEmptyColumns(emptyEColumnCount)}
            </TableRow>
          </TableHead>
          {/* <Divider /> */}
          <TableBody>{children}</TableBody>
        </Table>
      </TableContainer>
 
      {/* Pagination Component */}
      {displayPagination && (
        // <Paginations
        //   currentPage={currentPage}
        //   totalPages={pagination.totalPages}
        //   onPageChange={handlePageChange}
        // />
        <Paginations/>
      )}
       {/* <Paginations
      
       /> */}
       </>
    // </Card>
  );
};
 
export default TableComp;